import React, { lazy, Suspense }  from 'react'
import ReactDOM from 'react-dom'

import Loader from '@components/shared/loader/loader'
const JobApplicationForm = lazy(() => import('@components/job_application_form/job_application_form'))

document.addEventListener('DOMContentLoaded', () => {
  const elem = document.getElementById('job-application-form-body');

  ReactDOM.render(
    <Suspense fallback={Loader()}>
      <JobApplicationForm />
    </Suspense>,
    elem
  );
}, { once: true });
